import { minValue, numeric, requiredUnless } from 'vuelidate/lib/validators';
import { getSelectedItemsTitle } from './common';
import { vpDepartmentSizes, vpQuotaTypes } from '@/components/partials/jobs/constants/optionsDicts';
import { jobsVpManagedRoles } from '@/components/partials/jobs/constants/selectableOptions';
import { getOteIsLowerThanBaseSalaryValidation } from '@/components/partials/jobs/onboarding/utils';
import type {
  FormValidations,
  GetValidationPayload,
  InquiryForm,
} from '~/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export const getVpQuotaStructureFieldValue = (inquiry: InquiryForm) => {
  if (!inquiry.vpQuotaType) return null;

  return vpQuotaTypes[inquiry.vpQuotaType];
};

export const getVpDepartmentSizeFieldValue = (inquiry: InquiryForm) => {
  if (!inquiry.vpDepartmentSize) return null;

  return vpDepartmentSizes[inquiry.vpDepartmentSize];
};

export const getManagedRolesFieldValue = (inquiry: InquiryForm) => {
  if (!inquiry.vpManagedRoles) return '';

  const titles = getSelectedItemsTitle(inquiry.vpManagedRoles, jobsVpManagedRoles);

  if (!titles.length) return '';

  return titles.join(', ');
};

export const validateEditSalarySectionModalForm = ({
  form,
  hasAdminPrivilege,
}: GetValidationPayload): FormValidations => {
  return {
    vpDepartmentSize: {
      required: requiredUnless(() => hasAdminPrivilege),
    },
    baseSalary: { numeric, greaterThanZero: hasAdminPrivilege ? () => true : minValue(1) },
    ote: {
      numeric,
      oteIsLowerThanBaseSalary: getOteIsLowerThanBaseSalaryValidation({ form, required: true }),
    },
    revenue: { numeric, greaterThanZero: hasAdminPrivilege ? () => true : minValue(1) },
  };
};
